// Centralized service URL configuration.
// All deployment-specific base URLs live here and are read from the
// environment (.env). To change where this app points in another
// environment, edit the REACT_APP_* values in .env — no code changes needed.
//
// NOTE: Create React App only exposes vars prefixed with REACT_APP_.

// buildInfo.json is generated at build time by scripts/genBuildInfo.js (git-
// ignored). package.json is imported as a DEFAULT — CRA/webpack forbids importing
// a named export (e.g. `version`) from a JSON module.
import buildInfo from './buildInfo.json';
import pkg from '../package.json';

// Backend API server (Express). Includes the /api suffix.
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://127.0.0.1:3001/api';

// Backend origin without the /api suffix — used for the Socket.IO connection.
// Prefer explicit overrides; otherwise derive from the API URL.
export const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  API_BASE_URL.replace(/\/api\/?$/, '') ||
  'http://127.0.0.1:3001';

// ───────────────────────── Build / version info ─────────────────────────
// version  : the semver from package.json — the ONLY thing the user-facing
//            About dialog shows as the version (bump per release).
// builtAt  : ISO build timestamp (shown localized in About).
// commit   : git short SHA — OPERATOR-ONLY. Surfaced in the boot console banner
//            and window.__BUILD__, never rendered in the About dialog.
export const BUILD = {
  version: pkg.version,
  builtAt: buildInfo.builtAt || null,
  commit: buildInfo.sha || 'dev',
  commitFull: buildInfo.shaFull || '',
};
